export const fetchData = (values) => {
  return fetch("/session/token")
    .then((response) => response.text())
    .then((csrfToken) => {
      const data = values;

      return fetch("/api/inspiratiepunten_searchandfilter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify(data),
      });
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((responseData) => {
      return responseData.posts; // ✅ return posts to caller
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    });
};
